// extracted by mini-css-extract-plugin
module.exports = {"header":"Contacts2_header__1Fd44","divider":"Contacts2_divider__U5t_K","info":"Contacts2_info__2VIxQ","wrapper":"Contacts2_wrapper__2ehhg"};